import { createContext as t } from "react";
const e = /* @__PURE__ */ t(null);
export {
  e as PortalContext
};
//# sourceMappingURL=portal-context.js.map
